import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { useHttpClient } from '@repo/api-client/react';

const WebPushPublicKeySchema = z.object({
  publicKey: z.string().nullable(),
});

/**
 * `GET /v1/auth/web-push/public-key` — VAPID key for browser subscribe.
 */
export function useWebPushPublicKey() {
  const http = useHttpClient();
  return useQuery({
    queryKey: ['auth', 'web-push', 'public-key'] as const,
    queryFn: async () => {
      const { data } = await http.get('/auth/web-push/public-key');
      return WebPushPublicKeySchema.parse(data);
    },
    staleTime: 60 * 60 * 1000,
  });
}
